import { render, staticRenderFns } from "./MyAccountArtworkApprovals.vue?vue&type=template&id=9c39e360"
import script from "./MyAccountArtworkApprovals.vue?vue&type=script&lang=js"
export * from "./MyAccountArtworkApprovals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports